import React, { useEffect, useState } from "react";
import { Button, Snackbar } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import sendSchoolNotificationHook from "./hooks/sendSchoolNotificationHook";

const SchoolNotificationButton = ({
  subject,
  schoolId,
  pathwayEmail,
  opEmail,
}) => {
  const { sendSchoolNotification } = sendSchoolNotificationHook(schoolId);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleSendNotification = async () => {
    try {
      // Send notification to school
      const subjectData = {
        jsStruct: JSON.stringify({ subject, pathwayEmail, opEmail }),
      };
      await sendSchoolNotification(schoolId, subjectData);
      setSnackbarMessage("Notification has been sent");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error updating notification:", error);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        endIcon={<SendIcon />}
        onClick={handleSendNotification}
        sx={{ marginLeft: "105px" }}
      >
        Send
      </Button>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
      />
    </>
  );
};

export default SchoolNotificationButton;
